/* eslint-disable max-len */
import React from "react"
import Icon from "@ant-design/icons"

const LikertSvg = () => (
  <svg
    width="24"
    height="24"
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg">
    <rect width="24" height="24" rx="4" fill="#E2FCF6" />
    <path
      d="M8.75 9.25H15.25V14.75H8.75V9.25Z"
      fill="#E2FCF6"
      stroke="#55C8AE"
      strokeWidth="0.5"
    />
    <path
      d="M14.75 9.25H19.5C19.9142 9.25 20.25 9.58579 20.25 10V14C20.25 14.4142 19.9142 14.75 19.5 14.75H14.75V9.25Z"
      fill="#E2FCF6"
      stroke="#55C8AE"
      strokeWidth="0.5"
    />
    <path
      d="M3.75 10C3.75 9.58579 4.08579 9.25 4.5 9.25H9.25V14.75H4.5C4.08579 14.75 3.75 14.4142 3.75 14V10Z"
      fill="#E2FCF6"
      stroke="#55C8AE"
      strokeWidth="0.5"
    />
  </svg>
)

const LikertIcon = (props) => <Icon component={LikertSvg} {...props} />

export { LikertIcon }
